import { Field, Flex, Icon } from "@chakra-ui/react";
import React, { FC, type PropsWithChildren, useState } from "react";
import { LuInfo } from 'react-icons/lu';
import { useTheme } from "@emotion/react";

const FieldLabel = Field.Label as FC<PropsWithChildren<{ htmlFor?: string }>>;
const FieldHelperTextSlot = Field.HelperText as FC<
  PropsWithChildren<{ mb?: string }>
>;

type formLabelWithHelpProps = {
  labelText: string;
  helpText: string;
};

export const FormLabelWithHelp: FC<formLabelWithHelpProps> = ({
  labelText,
  helpText,
}) => {
  const [helpTextVisible, setHelpTextVisible] = useState(false);
  const theme = useTheme();
  return (
    <React.Fragment>
      <Flex alignItems="center">
        <FieldLabel htmlFor="urbanisation">{labelText}</FieldLabel>
        <Icon
          as={LuInfo}
          onClick={() => setHelpTextVisible(!helpTextVisible)}
          mb="8px"
          color={theme.colors.text.tertiary} />
      </Flex>
      {helpTextVisible && (
        <FieldHelperTextSlot mb="5px">{helpText}</FieldHelperTextSlot>
      )}
    </React.Fragment>
  );
};
